import en from './en.json';
import fr from './fr.json';

const labels = {
  en,
  fr
}

export default labels;